import { render, staticRenderFns } from "./room-carousel.vue?vue&type=template&id=8b9a195c&scoped=true&"
import script from "./room-carousel.vue?vue&type=script&lang=js&"
export * from "./room-carousel.vue?vue&type=script&lang=js&"
import style0 from "./room-carousel.vue?vue&type=style&index=0&id=8b9a195c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b9a195c",
  null
  
)

export default component.exports